import styles from './TextBadge.styles.scss';
import { TextBadgeComponent, textBadgeTemplate } from './TextBadge';
export const textBadgeDefinition = {
    baseName: 'text-badge',
    template: textBadgeTemplate,
    styles: styles,
};
export const chameleonTextBadge = TextBadgeComponent.compose(textBadgeDefinition);
